import { render, staticRenderFns } from "./CameraPageShootMessageGpdoc.vue?vue&type=template&id=14664ac3&scoped=true&"
import script from "./CameraPageShootMessageGpdoc.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootMessageGpdoc.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPageShootMessageGpdoc.vue?vue&type=style&index=0&id=14664ac3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14664ac3",
  null
  
)

export default component.exports